
<div>
  <div class="is-flex is-align-content-center is-justify-content-center is-text-center">
    <button class="control-button-minus flex justify-center items-center" :disabled="disabled || localValue === minimum || loading" @click="change(-1)">
      <img src="@/images/quote-builder/minus.svg" alt="Minus">
    </button>
   
    <div class="order-item-quantity flex items-center justify-center">
      <p>{{ localValue }}</p>
    </div>
   
    <button class="control-button-plus flex justify-center items-center" :disabled="disabled || localValue === maximum || loading" @click="change(+1)">
      <img src="@/images/quote-builder/plus.svg" alt="Plus">
    </button>
  </div>
  <!--<a href="#" class="is-flex has-text-danger is-align-content-center is-justify-content-center is-text-center is-size-7 mt-1" @click.prevent="change(-localValue)">
    <span v-if="localValue > 1" >Reset</span>
    <span v-else>&nbsp;</span>
  </a>-->
</div>
